<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap" rel="stylesheet" />
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />

<div id="uploadPanel1" *ngIf="!this.showFileForm">
  <form [formGroup]="uploadForm">
    <input type="file" #file style="display: none" multiple />
    <div class="container upload" fxLayout="column" fxLayoutAlign="space-evenly stretch" appDnd (fileDropped)="onFileDropped($event)">
      <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
      <h1 style="position: relative; top: -30px; left: -9px">
        <mat-icon class="fileroom-cloud-upload-icon" alt="cloud upload">cloud_upload</mat-icon>
      </h1>
      <h4 style="position: relative; top: -35px">
        Drag and drop<br />
        or<br />
        <button mat-raised-button class="fileroom-button fileroom-upload-button" style="color: #fff !important">Browse</button>
      </h4>
    </div>
    <div class="container" style="padding-top: 0; margin-top: 10px; text-align: justify">
      Hint: If you would like to tie a file or document to a specific entity (example, a household or work order) please upload from the
      entity itself.
    </div>

    <div class="files-list">
      <div class="single-file" *ngFor="let theFile of files; let i = index">
        <span class="fileroom-extension {{ getFileExtension(theFile) }}">{{ getFileExtension(theFile) }}</span>
        <div class="info">
          <h4 class="name">{{ theFile.file?.name }}</h4>
          <p class="size">{{ formatBytes(theFile.file?.size) }}</p>
        </div>

        <span mat-icon-button [matMenuTriggerFor]="appMenu1" class="fileroom-row-action">
          <mat-icon>more_vert</mat-icon>
        </span>

        <mat-menu #appMenu1="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item class="fileroom-button-flat red" (click)="deleteFile(i)">Delete</button>
          </ng-template>
        </mat-menu>
      </div>
      <div *ngIf="files?.length >= 1" class="container" style="padding-top: 0; margin-top: 10px; text-align: center">
        <button
          mat-raised-button
          class="fileroom-button fileroom-upload-button btn btn-danger danger"
          style="margin-right: 10px"
          (click)="cancelUpload()"
        >
          <span *ngIf="!this.enableExtendedEntry">Cancel</span>
        </button>
        <button mat-raised-button class="fileroom-button fileroom-upload-button" (click)="moveNext()">
          <span *ngIf="!this.enableExtendedEntry">Confirm</span><span *ngIf="this.enableExtendedEntry">Next</span>
        </button>
      </div>
    </div>
  </form>
</div>

<div id="uploadPanel2" *ngIf="this.showFileForm && this.enableExtendedEntry">
  <h1>Edit New Uploads</h1>
  <mat-table matSort [dataSource]="this.files" width="100%" style="width: 100%; min-width: 100%">
    <ng-container matColumnDef="upload-extension">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let file" style="width: 50px !important; max-width: 65px">
        <span class="fileroom-extension {{ getFileExtension(file) }} ">{{ getFileExtension(file) }} </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="upload-name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>

      <mat-cell *matCellDef="let file" style="width: 150px !important; max-width: 165px; margin-top: 10px; margin-left: 10px">
        <mat-form-field appearance="outline">
          <mat-label style="display: none">Name</mat-label>
          <input type="text" matInput [value]="theFile.file.name" />
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="upload-tags">
      <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
      <mat-cell *matCellDef="let file" style="overflow: unset; margin-top: 10px; margin-left: 10px">
        <mat-form-field appearance="outline">
          <mat-label style="display: none">Tags</mat-label>
          <mat-select multiple (selectionChange)="updateFileTags(file, $event)">
            <mat-option>All</mat-option>
            <mat-option *ngFor="let tag of this.tags" [value]="theFile.file.tags">
              {{ tag.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="upload-department">
      <mat-header-cell *matHeaderCellDef>Department</mat-header-cell>
      <mat-cell *matCellDef="let file" style="overflow: unset; margin-top: 10px; margin-left: 10px">
        <mat-form-field appearance="outline">
          <mat-label style="display: none">Department</mat-label>
          <mat-select name="department" multiple (selectionChange)="updateFileDepartments(file, $event)">
            <mat-option>All</mat-option>
            <mat-option *ngFor="let dept of this.departments" [value]="theFile.file.departments">
              {{ dept.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="upload-actions" stickyEnd>
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let theFile" style="width: 35px !important; max-width: 50px; margin-top: 10px; margin-left: 10px">
        <span mat-icon-button [matMenuTriggerFor]="appMenu" class="fileroom-row-action">
          <mat-icon>more_vert</mat-icon>
        </span>

        <mat-menu #appMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item class="fileroom-button-flat red" (click)="deleteById(theFile.id)">Delete</button>
          </ng-template>
        </mat-menu>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <div *ngIf="files.length >= 1" class="container" style="padding-top: 0; margin-top: 10px; text-align: center">
    <button mat-raised-button class="fileroom-button fileroom-upload-button" (click)="save()">Save</button>
  </div>
</div>
